/**
 * Created by Qingger Corp.
 * User: yangzihua
 * Date: 2019/8/7
 * Time: 10:49
 * Desc: 分销报表
 */

/**
 * Created by Qingger Corp.
 * User: yangzihua
 * Date: 2019/6/17
 * Time: 17:38
 * Desc: 云店设置-分类配置
 */

import { Component, Vue } from 'vue-property-decorator';

// 子组件
import DistributorTransaction from '@/views/components/distributorTransaction/distributorTransaction.vue'; // 商品分类配置
import VGuider from '@/views/components/vGuider/vGuider.vue';

@Component({
  components: {
    DistributorTransaction,
    VGuider,
  },
})
export default class GuiderBoard extends Vue {
  /* 数据 */

  /**
   * 当前类型
   * @type {string}
   */
  public curTab = '1';

  /**
   * 运营模式
   * 1 镜像店单店 2 镜像店千店 3 云商城单店 4 云商城千店
   * @type {number}
   */
  public mode = 0;

  /* 方法 */

  /**
   * 类型切换
   * @param {string} index
   */
  public onSwitchTab(index: string): void {
    this.curTab = index;
    localStorage.setItem('curTab', index);
  }

  /* 周期 */

  /**
   * 当组建加载时
   */
  public created() {
    this.mode = +this.$route.params.mode;
    // 获取当前页索引
    this.curTab = localStorage.getItem('curTab') ? localStorage.getItem('curTab') : '1';
  }

  render() {
    return (
      <div class="categoryConfig" style="height: 100%">
        <el-container class="categoryConfig" style="height: 100%">
          <el-aside width="100%">
            <el-tabs tab-position="left" class="el-tabs" v-model={this.curTab}>
              <el-tab-pane label="分销员汇总表" class="el-tab-pane" name={'1'}>
                {this.curTab === '1' && <VGuider />}
              </el-tab-pane>
              <el-tab-pane label="分销员成交报表" class="el-tab-pane" name={'2'}>
                {this.curTab === '2' && <DistributorTransaction />}
              </el-tab-pane>
            </el-tabs>
          </el-aside>
        </el-container>
      </div>
    );
  }
}
